export default __webpack_public_path__ + "static/media/DOM-SEPT2025.f64377b7.png";